import { headerLogoStartTitle } from './HeaderLogoStore.js';

export const updateHeaderLogoStartTitle = (value) => headerLogoStartTitle.update((oldValue) => value);
